import React, { ReactElement, useEffect, useRef, useState } from 'react'
import cloud from 'd3-cloud'
import { CloudWord, GraphProps, WORDCLOUD_MAX_WORDS, WORDCLOUD_WIDTH, WORDCLOUD_HEIGHT } from './Graph.d'

const WordCloud = ({ data, onClick }: GraphProps): ReactElement => {
    const { title, data: rows } = data
    const [placed, setPlaced] = useState<CloudWord[]>([])
    const layoutRef = useRef<ReturnType<typeof cloud> | null>(null)

    useEffect(() => {
        const sorted = [...rows]
            .sort((a, b) => Number(b.count ?? 0) - Number(a.count ?? 0))
            .slice(0, WORDCLOUD_MAX_WORDS)
        const maxCount = Number(sorted[0]?.count ?? 1)

        const words: CloudWord[] = sorted.map(row => ({
            text: String(row.word ?? ''),
            size: Math.round(11 + (Number(row.count ?? 0) / maxCount) * 42),
            colour: row.country_colour ? String(row.country_colour) : undefined
        }))

        layoutRef.current = cloud<CloudWord>()
            .size([WORDCLOUD_WIDTH, WORDCLOUD_HEIGHT])
            .words(words)
            .padding(3)
            .rotate(0)
            .font('sans-serif')
            .fontSize(d => d.size ?? 12)
            .on('end', setPlaced)
            .start()

        return () => {
            layoutRef.current?.stop()
        }
    }, [rows])

    return (
        <div className="graph graph__cloud" onClick={ onClick }>
            { title && <h3 className="graph__title">{ title }</h3> }
            <svg className="graph__cloud-svg" viewBox={ `0 0 ${WORDCLOUD_WIDTH} ${WORDCLOUD_HEIGHT}` }>
                <g transform={ `translate(${WORDCLOUD_WIDTH / 2},${WORDCLOUD_HEIGHT / 2})` }>
                    { placed.map(w => (
                        <text
                            key={ w.text }
                            style={ { fontSize: w.size, fontFamily: 'sans-serif', fill: w.colour ?? 'currentColor' } }
                            textAnchor="middle"
                            transform={ `translate(${w.x ?? 0},${w.y ?? 0})` }
                        >
                            { w.text }
                        </text>
                    )) }
                </g>
            </svg>
        </div>
    )
}

export default WordCloud
